<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "Permission",
        components: {CommonTable},
        data(){
            return{
                permission:{
                    add: 'permission:add',
                    update: 'permission:update',
                    delete: 'permission:delete',
                    deleteBatch: 'permission:deleteBatch'
                },
                url: {
                    get: '/permission/all',
                    add: '/permission/add',
                    update: '/permission/update',
                    delete: '/permission/delete/',
                    delete_batch: '/permission/deleteBatch',
                },
                tableColumns: [{
                    field: 'name',
                    label: '名称',
                    show: true,
                    width: '',
                },{
                    field: 'permission',
                    label: '权限名',
                    show: true,
                    width: '',
                },],
                formFields: {
                    addTitle: '添加权限',
                    updateTitle: '修改权限',
                    model: [{
                        field: 'name',
                        label: '名称：',
                        type: 'input',
                        placeholder: '权限名称',
                        rules:[{required: true, message: '请输入权限名称', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'parentId',
                        label: '父权限：',
                        type: 'select',
                        placeholder: '请选择',
                        rules:[],
                        selectUrl: '/permission/parent',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    },{
                        field: 'permission',
                        label: '权限名：',
                        type: 'input',
                        placeholder: '权限名',
                        rules:[/*{required: true, message: '请输入权限名', trigger: 'blur'}*/],
                        add: true,
                        update: true,
                    },]
                },
                operate:[],
            }
        }
    }
</script>

<style scoped>

</style>
